// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb-link":"breadcrumb-link__uKO7j","stickyRight":"stickyRight__jB4n9","live-bg-color":"live-bg-color__3AYp6","closed-text-color":"closed-text-color__3kxcI","upcoming-text-color":"upcoming-text-color__3G_FD"};


//////////////////
// WEBPACK FOOTER
// ./styles/nfo/nfoListing.scss
// module id = 745
// module chunks = 68